/**
 * 课程标准 api
 * 课程标准api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The FragmentResCreateForm model module.
   * @module course_standard/model/FragmentResCreateForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>FragmentResCreateForm</code>.
   * @alias module:course_standard/model/FragmentResCreateForm
   * @class
   * @param mediaUrl {String} 媒体url
   * @param type {Integer} 媒体资源类型 1:视频；2音频
   */
  var exports = function(mediaUrl, type) {
    var _this = this;

    _this['mediaUrl'] = mediaUrl;
    _this['type'] = type;
  };

  /**
   * Constructs a <code>FragmentResCreateForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:course_standard/model/FragmentResCreateForm} obj Optional instance to populate.
   * @return {module:course_standard/model/FragmentResCreateForm} The populated <code>FragmentResCreateForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'mediaUrl')) {
        obj['mediaUrl'] = ApiClient.convertToType(data['mediaUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * 媒体url
   * @member {String} mediaUrl
   */
  exports.prototype['mediaUrl'] = undefined;
  /**
   * 媒体资源类型 1:视频；2音频
   * @member {Integer} type
   */
  exports.prototype['type'] = undefined;



  export default exports;
;


